import { Navigate } from "react-router-dom";
import { isAuthenticated } from "../utils/auth";

const GuestRoute = ({ children }) => {

    if (isAuthenticated()) {
        return <Navigate to="/home-clientes" replace />;
    }

    return children;
};

export default GuestRoute;